/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FacilityMetricsResponse { 
    facilityId: string;
    facilityName: string;
    activeCount: number;
    idleCount: number;
    totalHashrate: number;
    totalSolHashrate: number;
    averageTemperature: number;
    totalPower: number;
    freePower: number;
}

